// Numbers as the director writes them (2 Nov 2026: "all the decimal points
// are commas, and thousand separators is a space"): "29 120", "1 066,5",
// "€ 8 415,17" -- on every screen, whatever locale a page asks for, so no page
// can forget. The space is a non-breaking one, so a number never wraps across
// two lines. Dates are left as they are.
//
// Loaded first, by src/index.js. Typed boxes still read either way: the
// invoice form takes "0,2181" and "0.2181" alike.

const native = Number.prototype.toLocaleString;
// eslint-disable-next-line no-extend-native
Number.prototype.toLocaleString = function toLocaleString(_locales, options) {
  return native.call(this, 'en-GB', options).replace(/[,.]/g, (c) => (c === ',' ? ' ' : ','));
};

// A value put together from empty fields reads as a dash, not "null°C".
export const filled = (v) => (typeof v === 'string' && /null|undefined/.test(v) ? '—' : v);

// A decimal for a typed box: a comma, no thousand separator (so it reads back).
export const field = (v) => (typeof v === 'number' && Number.isFinite(v) ? String(v).replace('.', ',') : (v ?? ''));
// A number written by hand with `d` decimals, as above: "12,5".
export const dec = (v, d = 1) => (Number.isFinite(Number(v)) ? Number(v).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d }) : '');
